<template>
    <div class="ms-auto">

        <button class="btn btn-light btn-sm dropdown-toggle" type="button" id="appSettingsDropdown"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-cog pointer"></i>
        </button>
        <div class="dropdown-menu">
            <h6 class="dropdown-header">Table</h6>

            <div @click="onEditClick" class="pointer dropdown-item">
                <i class="fal fa-pencil text-secondary me-1 menu-icon"></i>
                <a class="no-underline menu-link" href="javascript:void(0)">Edit</a>
            </div>

            <div @click="onDeleteClick" class="pointer dropdown-item">
                <i class="fal fa-trash text-secondary me-1 menu-icon"></i>
                <a class="no-underline menu-link" href="javascript:void(0)">Delete</a>
            </div>

        </div>

        <table-modal v-if="showTableModal" @noEvent="showTableModal = false" :table="table"></table-modal>

        <confirm-modal key="deleteTableModal"
                       v-if="showConfirmTableModal"
                       @noEvent="showConfirmTableModal = false"
                       :yesEvent="deleteTable"
                       text="Are you sure you want to delete this table?">
        </confirm-modal>

    </div>


</template>

<script>
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import ModelService from "../../services/ModelService";
    import TableModal from "../../components/TableModal.vue";
    export default {
        name: 'TableDropdown',
        components: {TableModal, ConfirmModal},
        props: ['table', 'view'],
        data () {
            return {
                model: webase.model,
                service: new ModelService(),
                showTableModal: false,
                showConfirmTableModal: false,
                deleteTable: function () {
                }
            }
        },
        mounted () {
        },
        methods: {
            onEditClick() {
                this.showTableModal = true
            },
            onDeleteClick() {
                this.showConfirmTableModal = true

                this.deleteTable = () => {

                    this.service.remove(this.table.id).then(() => {
                        this.showConfirmTableModal = false
                        this.$router.push({name: 'open-app', params: {id: this.model.app.id}})
                    }).catch((error) => {
                        console.log('Error removing table.')
                        console.log(error)
                        this.showConfirmTableModal = false
                    })
                }
            },
        }
    }
</script>

<style>

</style>
